<template>
    <custom-drawer
        v-loading="m__loading"
        size="55%"
        :wrapper_closable="false"
        :visible.sync="visible_in_line"
    >
        <template slot="title">
            <div class="flex items-center justify-between flex-1 h-full pr-5">
                <div>
                    <p class="font-semibold text-[0.9rem]">
                        {{ this.$t('page.campaign.adgroup_pane.edit_adgroup') }}
                    </p>
                    <p
                        v-if="selected_item"
                        class="text-desc-text text-[0.75rem]"
                    >
                        {{ $t('table.header.ad_group_id') }} :
                        {{ selected_item.adgroup.adgroup_id }}
                    </p>
                </div>
                <el-button
                    icon="el-icon-check"
                    type="primary"
                    size="small"
                    @click="handleEditAdgroup()"
                >
                    {{ $t('button.confirm') }}
                </el-button>
            </div>
        </template>

        <div v-if="selected_adgroup" class="px-5 py-8">
            <EditAdGroupForm
                :selected_item.sync="selected_adgroup"
                :currency="selected_item.currency"
                :timezone="selected_item.timezone"
                :tiktok_account_id="tiktok_account_id"
                :belong_to_atosa="belong_to_atosa"
                :advertiser_id="advertiser_id"
                :objective_type="objective_type"
                type_form="edit"
            ></EditAdGroupForm>
        </div>
    </custom-drawer>
</template>

<script>
import EditAdgroupFormMixin from '@/components/orgranisms/edit-adgroup-form/_mixin'
import { getCampaigns } from '@/services/atosa-tiktok-ads/campaign'
import { updateAdgroup } from '@/services/atosa-tiktok-ads/adgroup'
import { removeEmptyParams } from '@/views/campaign/_utils'

export default {
    mixins: [EditAdgroupFormMixin],

    props: [
        'visible',
        'selected_item',
        'tiktok_account_id',
        'advertiser_id',
        'belong_to_atosa'
    ],

    data() {
        return {
            objective_type: '',
            selected_adgroup: null
        }
    },

    computed: {
        visible_in_line: {
            get: function () {
                return this.visible
            },
            set: function (val) {
                this.$emit('update:visible', val)
            }
        }
    },

    watch: {
        selected_item() {
            this.selected_adgroup = {
                ...this.selected_item.adgroup,
                extension: this.p__default_state_infor_adgroup.extension
            }
            console.log(this.selected_adgroup)
            this.fetchDetailCampaign()
        }
    },

    mounted() {
        this.fetchDetailCampaign()
    },

    methods: {
        async handleEditAdgroup() {
            if (!this.m__validAdgroup(this.selected_adgroup, 'edit')) {
                return
            }

            this.m__loading = true

            try {
                const temp = { ...this.selected_adgroup }
                removeEmptyParams(temp)

                this.m__changeScheduleTime2(temp)

                await updateAdgroup(this.tiktok_account_id, {
                    ...temp,
                    belong_to_atosa: this.belong_to_atosa,
                    advertiser_id: this.advertiser_id,
                    adgroup_id: temp.adgroup_id
                })
                this.p__event_bus.$emit('eb_reload_adgroup')

                this.p__showNotify(
                    'success',
                    this.$t('common.update_data_success')
                )
                this.visible_in_line = false
            } catch (error) {
                console.error(error)
            }

            this.m__loading = false
        },

        async fetchDetailCampaign() {
            if (!this.selected_adgroup) {
                return
            }

            const response = await getCampaigns(this.tiktok_account_id, {
                advertiser_id: this.advertiser_id,
                filtering: JSON.stringify({
                    campaign_ids: [this.selected_adgroup.campaign_id]
                })
            })
            if (
                response.code === 0 &&
                response.data.list.length &&
                response.data.list[0]
            ) {
                const first_campaign = response.data.list[0]

                this.objective_type = first_campaign.objective_type
            }
        }
    }
}
</script>
